import { IReferentielWebServiceClient } from "@resources/resources";
import { Injectable } from "@angular/core";
import { Resolve } from "@angular/router";

@Injectable()
export class TypesReferentielResolver implements Resolve<Array<String>> {

  constructor(private referentielWebService: IReferentielWebServiceClient) {
  }

  resolve() {
    return this.referentielWebService.typesModification();
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/src/app/pages/cerba/pages/historique-modifications/filtres/types.referentiel.resolver.ts